module.exports = __webpack_public_path__ + "static/jimmy-stitz-gold-tokyo-97d1ccd5f8dcfa43008097ea64ae5398.jpg";